'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.tooltip = twentyninetimes.tooltip || function () {

	function init() {
		var tooltips = document.querySelectorAll('.tooltip');
		if ( tooltips ) {
      tooltips.forEach(tooltip => {
        showTooltip(tooltip);
      });
		}
	}

  function showTooltip(tooltip) {
    tooltip.addEventListener('click', (e) => {
      var content = tooltip.querySelector('.tooltip__content'),
          rect = content.getBoundingClientRect();

      if ( !tooltip.classList.contains('active') ) {
        tooltip.classList.add('active');

        if (rect.right > window.innerWidth) {
          tooltip.classList.add('align-right');
        }
      } else {
        tooltip.classList.remove('active');

        setTimeout(() => {
          tooltip.classList.remove('align-right');
        }, 500);
      }

    });
  }

  return {
		init : init
	};

}();